exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group_questions[data-v-73aad736] {\n  padding: 0px 0px 40px 0px;\n  border-bottom: 1px solid #ddd;\n}\nth[data-v-73aad736] {\n  padding-left: 15px;\n  padding-right: 15px;\n  font-size: 20px;\n}\ntd[data-v-73aad736],\nth[data-v-73aad736] {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n.row-first-choice[data-v-73aad736] {\n  background-color: lightgreen;\n}\n.row-second-choice[data-v-73aad736] {\n  background-color: lightyellow;\n}\nh2[data-v-73aad736] {\n  margin-bottom: 0;\n}\n.highlight[data-v-73aad736] {\n  margin: 15px 0px;\n  border: 2px solid #881313;\n}\n", ""]);

// exports
